import { customElement } from '@aurelia/runtime-html';
import * as __au2ViewDef from './auto-save.html';
import { GlobalDefinition } from "resources/global_definitions";
import { PersistencyHandler } from "resources/persistency_handler";

import { Logger } from 'resources/services/logger';

@customElement(__au2ViewDef)
export class AutoSave {

    constructor(
        private globalObjectInstance: GlobalDefinition,
        private logger: Logger,
        private persistencyHandler: PersistencyHandler
    ) {
    }

    async attached() {
        // start 5 sec interval
        // if the autoSave is true, and the globalObjectInstance doSceneInstancePatch is true,
        // make a patch to the server
        setInterval(async () => {
            if (this.globalObjectInstance.autoSave && this.globalObjectInstance.doSceneInstancePatch) {
                this.logger.log('AutoSave: ' + this.globalObjectInstance.autoSave, 'info');
                await this.persistencyHandler.persistSceneInstanceToDB();
                this.globalObjectInstance.doSceneInstancePatch = false;
            }
        }, 5000);
    }

    //when the toggle button is clicked the camera is changed from 2d to 3d and vice versa
    //this includes also seperate orbitcontrols for 2d and 3d
    async toggle() {
        this.globalObjectInstance.autoSave = !this.globalObjectInstance.autoSave;
        this.logger.log('CameraToggle toggle ' + this.globalObjectInstance.autoSave, 'info')
    }
}
    import { Metadata as $$M } from '@aurelia/metadata';
    import { ExpressionKind as $$EK } from '@aurelia/runtime';
    import { Controller as $$C, CustomElement as $$CE, IHydrationContext as $$IHC } from '@aurelia/runtime-html';

    // @ts-ignore
    const controllers = [];

    // @ts-ignore
    if (module.hot) {

    // @ts-ignore
    module.hot.accept();

    // @ts-ignore
    const hot = module.hot;

    let aurelia = hot.data?.aurelia;

    // @ts-ignore
    document.addEventListener('au-started', (event) => {aurelia= event.detail; });
    const currentClassType = AutoSave;

    // @ts-ignore
    const proto = AutoSave.prototype

    // @ts-ignore
    const ogCreated = proto ? proto.created : undefined;

    if (proto) {
      // @ts-ignore
      proto.created = function(controller) {
        // @ts-ignore
        ogCreated && ogCreated.call(this, controller);
        controllers.push(controller);
      }
    }

    // @ts-ignore
    hot.dispose(function (data) {
      // @ts-ignore
      data.controllers = controllers;
      data.aurelia = aurelia;
    });

    if (hot.data?.aurelia) {
      const newDefinition = $$CE.getDefinition(currentClassType);
      $$M.define(newDefinition.name, newDefinition, currentClassType);
      $$M.define(newDefinition.name, newDefinition, newDefinition);
      hot.data.aurelia.container.res[$$CE.keyFrom(newDefinition.name)] = newDefinition;

      const previousControllers = hot.data.controllers ?? [];
      if(previousControllers.length === 0) {
        // @ts-ignore
        hot.invalidate?.();
      }

      // @ts-ignore
      previousControllers.forEach(controller => {
        const values = { ...controller.viewModel };
        const hydrationContext = controller.container.get($$IHC)
        const hydrationInst = hydrationContext.instruction;

        const bindableNames = Object.keys(controller.definition.bindables);
        // @ts-ignore
        Object.keys(values).forEach(key => {
          if (bindableNames.includes(key)) {
            return;
          }
          // if there' some bindings that target the existing property
          // @ts-ignore
          const isTargettedByBinding = controller.bindings?.some(y =>
            y.ast?.$kind === $$EK.AccessScope
              && y.ast.name === key && y.targetProperty
          );
          if (!isTargettedByBinding) {
            delete values[key];
          }
        });
        const h = controller.host;
        delete controller._compiledDef;
        controller.viewModel = controller.container.invoke(currentClassType);
        controller.definition = newDefinition;
        Object.assign(controller.viewModel, values);
        if (controller._hydrateCustomElement) {
          controller._hydrateCustomElement(hydrationInst, hydrationContext);
        } else {
          controller.hE(hydrationInst, hydrationContext);
        }
        h.parentNode.replaceChild(controller.host, h);
        controller.hostController = null;
        controller.deactivate(controller, controller.parent ?? null, 0);
        controller.activate(controller, controller.parent ?? null, 0);
      });
    }
  }